/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_PhoneInputs */

const vi_grower_phone = /** @type {(inputs: Grower_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại`)
};

/**

* @param {Grower_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_phone = /** @type {((inputs?: Grower_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_phone(inputs)
});